import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import FullstoryScript from "/components/core/head/fullstory-scripts/fullstory-script";
import TrustpilotScript from "/components/core/head/seo-scripts/trustpilot-script";
import IntercomScript from "/components/core/head/intercom-scripts/intercom-script";
import { initBodyScripts } from "services/body-scripts-service";
import { withAbTests } from "/contexts/ab-tests-context";
import { withGenericConfig } from "/contexts/generic-config-context";
import GoogleTagManagerComponent from "/components/core/google-tag-manager/google-tag-manager-component";
import HotjarScript from "/components/core/head/hotjar-script";
import { trackEvent } from "/services/bigbrain-service";
import { RETRIEVED_404_ERROR } from "constants/bigbrain-event-types";
import { withRouter } from "next/router";
import { currentSmallerThanFinalDate } from "client/services/hotjar-service/hotjar-service";
import { enableBotOnPage, handleChatReady } from "./ada-bot";
const isProduction = process.env.NODE_ENV === "production";
const HotjarWithAbTests = withAbTests(HotjarScript);
const CHAT_READY_FOR_REQUEST = "chat-ready-for-requests";
const BodyScriptsComponent = (props)=>{
    const { abTests, withFullstory, fullstoryRecordingFrequency, showTrustpilotReviews, withIntercom, disableGTM, gtmContainerId, enableHotjar, hotjarFinalDate, clusterId, hasFreeTier, localeId, subClusterId, loggedInUser, is404Page, customBodyScript, useAdaBot } = props;
    useEffect(()=>{
        initBodyScripts({
            abTests
        });
    }, [
        abTests
    ]);
    useEffect(()=>{
        if (is404Page) {
            var _window_location, _window, _document;
            const href = (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href;
            const referrer = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer;
            trackEvent(RETRIEVED_404_ERROR, {
                kind: href,
                info1: referrer
            });
        }
    }, [
        is404Page
    ]);
    useEffect(()=>{
        if (useAdaBot) {
            enableBotOnPage(localeId);
            document.addEventListener(CHAT_READY_FOR_REQUEST, handleChatReady);
            return ()=>{
                document.removeEventListener(CHAT_READY_FOR_REQUEST, handleChatReady);
            };
        }
    }, [
        useAdaBot
    ]);
    const loggedInUserToUse = loggedInUser || {};
    const shouldAddHotjarScript = ()=>{
        return enableHotjar && currentSmallerThanFinalDate(hotjarFinalDate);
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isProduction && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                !disableGTM && // This MUST be rendered in the body so componentDidMount will run
                /*#__PURE__*/ _jsx(GoogleTagManagerComponent, {
                    loadBodyScript: true,
                    gtmId: gtmContainerId
                }),
                withFullstory && /*#__PURE__*/ _jsx(FullstoryScript, {
                    clusterId: clusterId,
                    subClusterId: subClusterId,
                    fullstoryRecordingFrequency: fullstoryRecordingFrequency,
                    hasFreeTier: hasFreeTier,
                    localeId: localeId
                }),
                showTrustpilotReviews && /*#__PURE__*/ _jsx(TrustpilotScript, {}),
                withIntercom && /*#__PURE__*/ _jsx(IntercomScript, {
                    userData: {
                        userId: loggedInUserToUse.mondayUserId || loggedInUserToUse.id,
                        name: loggedInUserToUse.name,
                        email: loggedInUserToUse.email,
                        additionalData: loggedInUserToUse.intercomData
                    },
                    isProduction: isProduction
                }),
                shouldAddHotjarScript() && /*#__PURE__*/ _jsx(HotjarWithAbTests, {}),
                useAdaBot && /*#__PURE__*/ _jsx("div", {
                    id: "mf-growth-cx-root"
                }),
                customBodyScript && /*#__PURE__*/ _jsx("script", {
                    dangerouslySetInnerHTML: {
                        __html: customBodyScript
                    }
                })
            ]
        })
    });
};
export default withGenericConfig(withAbTests(withRouter(BodyScriptsComponent)));
BodyScriptsComponent.defaultProps = {
    withFullstory: false,
    showTrustpilotReviews: false,
    withIntercom: false,
    fontLazyLoad: false,
    disableGTM: false
};
